<template>
  <dashboard-layout>
    <basic-card>
      <template slot="header">
        List of Parties
      </template>
      <framed-content title="Filter">
        <form-wrapper>
          <form-text-input caption="Name" v-model="nameFilter"/>
          <form-multi-select-input :options="partyRoleTypesOptions" caption="Roles" v-model="roleTypeFilter"/>

        </form-wrapper>

      </framed-content>

      <data-table
          :data="filteredParties"
          :configuration="partiesTableConfig"
          @focusedChanged="focusedChanged"
          component-id="parties-list"
      >
        <party-form-card :party="focusedParty" v-if="focusedParty != null"/>
      </data-table>


    </basic-card>

  </dashboard-layout>
</template>

<script>
import {mapGetters} from "vuex";
import DashboardLayout from "../components/layout/DashboardLayout";
import DataTable from "../components/table/DataTable";
import PartyFormCard from "../cards/PartyFormCard";
import CollapsibleContent from "../components/CollapsibleContent";
import FormWrapper from "../components/form/FormWrapper";
import FormTextInput from "../components/form/FormTextInput";
import FormCheckboxInput from "../components/form/FormCheckboxInput";
import BasicCard from "../components/layout/BasicCard";
import FormMultiSelectInput from "@/components/form/FormMultiSelectInput";
import FramedContent from "@/components/layout/FramedContent";

export default {
  name: "PartiesView",
  components: {
    FramedContent,
    FormMultiSelectInput,
    BasicCard,
    FormCheckboxInput,
    FormTextInput, FormWrapper, CollapsibleContent, PartyFormCard, DataTable, DashboardLayout
  },
  data: function () {
    return {
      nameFilter: "",
      roleTypeFilter: [],
      focusedParty: null,
      partiesTableConfig: {
        selectionMode: "single",
        allowEdit: true,
        columns: [
          {
            caption: 'Id',
            datum: d => d.id
          },
          {
            caption: 'Name',
            datum: d => d.displayName
          },
          {
            caption: 'Roles',
            datum: d => d.partyRoles.length
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({
      parties: "parties/parties",
      partyRoleTypes: "partyRoleTypes/partyRoleTypes"
    }),
    partyRoleTypesOptions() {
      return this.partyRoleTypes.map(roleType => ({name: roleType.displayName, id: roleType.id}))
    },
    filteredParties() {
      return this.parties
          .filter(party => {
            return party.partyRoles.filter(role => this.roleTypeFilter.includes(role.partyRoleTypeId)).length > 0;
          })
          .filter(party => (party.displayName ?? "N/A").toLowerCase().includes(this.nameFilter.toLowerCase()));
    }
  },
  methods: {
    focusedChanged(focused) {
      this.focusedParty = focused;
    }
  },
  mounted() {
    this.roleTypeFilter = this.partyRoleTypesOptions.map(prt => prt.id);
  }
}
</script>

<style lang="scss" scoped>

</style>